
<template>
  <div>
    <div class="blogs">
      <div class="blogs-bg">
        <div class="blogs-bg-img">
          <img src="@/assets/blogs/banner.png" alt="">
        </div>
        <div class="blogs-bg-breadcrumb">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="/">{{ $t('blogs.breadcrumb.title') }}</a></li>
              <li class="breadcrumb-item active" aria-current="page">{{ $t('blogs.breadcrumb.activeTitle') }}</li>
            </ol>
          </nav>
        </div>
        <div class="blogs-bg-position">
          <div :class="positionActive == index?'blogs-bg-position-item blogs-bg-position-item-active':'blogs-bg-position-item'" v-for="(item, index) in navList" :key="index" @click="positionClick(item,index)">
            {{ item }}
          </div>
        </div>
        <div class="pc-fixed-icon" @click="openInquiryForm">
          <img src="@/assets/home/xinxi.png" alt="">
        </div>
      </div>
      <div class="blogs-cont">
        <div class="blogs-card">
          <div class="blogs-card-item" v-for="(item, index) in contactList" :key="index" @click="goDetail(item)">
            <img :src="item.image" alt="" class="blogs-card-item-img">
            <div class="blogs-card-item-Font">
              <strong>{{ item.title }}</strong>
              <p v-html="item.des"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>

</template>

<script>
import { bus } from '@/utils/bus'
import { getBannerListing,getNewsList } from '@/api/komo'
export default {
  name: 'blogs',
  data() {
    return {
      bannerList: [], //
      contactList: [],
      isShow:true,
      activeTab: 'brandPositioning',
      positionActive: 0,
      navList: [this.$t('blogs.tabs.Enterprise'), this.$t('blogs.tabs.Industry')],
      navActiveName:'',
      list:[],
      list1: [
        {
          img: require('@/assets/blogs/blogs-1.png'),
          title: this.$t('blogs.listTitle'),
          text: this.$t('blogs.listText')
        },
        {
          img: require('@/assets/blogs/blogs-2.png'),
          title: this.$t('blogs.listTitle'),
          text: this.$t('blogs.listText')
        },
        {
          img: require('@/assets/blogs/blogs-1.png'),
          title: this.$t('blogs.listTitle'),
          text: this.$t('blogs.listText')
        }
      ],
      list2: [
        {
          img: require('@/assets/blogs/blogs-2.png'),
          title: this.$t('blogs.listTitle'),
          text: this.$t('blogs.listText')
        },
        {
          img: require('@/assets/blogs/blogs-1.png'),
          title: this.$t('blogs.listTitle'),
          text: this.$t('blogs.listText')
        },
        {
          img: require('@/assets/blogs/blogs-2.png'),
          title: this.$t('blogs.listTitle'),
          text: this.$t('blogs.listText')
        }
      ],
      chidList: {
        tabName: '',
        id:''
      }
    };
  },
  async created() {
    
  },
  methods: {
    async bannerData () {
      // this.isShow = true;
      const result = await getBannerListing('7');
      this.bannerList = result.data.list;
    },
    async contactData (tabName) {
      let params = {
        type: tabName,
        search:''
      }
      const contactDatalist = await getNewsList(params);
      this.contactList = contactDatalist.data.list;
    },
    openInquiryForm(){
      bus.$emit('inquiry-form', true)
    },
    positionClick (item,index) {
      console.log(item, index);
      this.navActiveName = item;
      this.positionActive = index;
      let tabName = ''
      if(this.navActiveName == this.$t('blogs.tabs.Enterprise')){
        tabName = 'enterprise'
      } else if(this.navActiveName == this.$t('blogs.tabs.Industry')){
        tabName = 'industry'
      }
      this.contactData(tabName);
    },
    goDetail (item) {
      // this.isShow = false;
      // this.chidList = {
      //   tabName: this.navActiveName,
      //   id: item.id
      // }
      this.$router.push({
        name: 'blogsDetail',
        params: {
          type:item.type,
          id: item.id
        }
      })
    }
  },
  mounted() {
    // 页面挂载后执行逻辑
    this.list = this.list1;
    this.navActiveName = this.navList[this.positionActive];
    let tabName = ''
    if(this.navActiveName == this.$t('blogs.tabs.Enterprise')){
      tabName = 'enterprise'
    } else if(this.navActiveName == this.$t('blogs.tabs.Industry')){
      tabName = 'industry'
    }
    this.bannerData()
    this.contactData(tabName);
  }
};
</script>

<style scoped>
/* 样式部分 */
.blogs {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}
.blogs-bg {
  width: 100%;
  height: 100%;
  position: relative;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 2%;
}
.blogs-bg-img{
  width: 100%;
  height: 580px;
}
.blogs-bg-img img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.blogs-bg-breadcrumb{
  width: 80%;
  height: 10%;
  background: #FFFFFF;
  box-shadow: 0px 13px 45px 0px rgba(210,210,210,0.5);
  border-radius: 60px;
  display: flex;
  align-items: center;
  padding-left: 3%;
  position: absolute;
  top: calc(580px - 5%);
  left: 10%;
  z-index: 1;
}
.blogs-bg-breadcrumb .breadcrumb{
  margin: 0;
  font-size:1.5rem;
}
.blogs-bg-breadcrumb .breadcrumb a{
  color: #959595;
  text-decoration: none;
}
.blogs-bg-breadcrumb .breadcrumb-item.active{
  font-weight: bold;
  color: #1E1E1E;
}
.blogs-bg-position{ 
  width: 80%;
  margin: 5% auto 0;
  height: 46px;
  display: flex;
  justify-content: center;
  gap: 8%;
}
.blogs-bg-position-item{
  padding: 1%;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.blogs-bg-position-item a{
  color: #1E1E1E;
  text-decoration: none;
}
.blogs-bg-position-item-active{
  background: #D5DCC866;
  font-weight: bold;
}
.blogs-bg-information{
  position: fixed;
  bottom: 0%;
  right: 7%;
  width: 12vw;
  height: 12vw;
  cursor: pointer;
  z-index: 99;
}
.blogs-bg-information img{
  width: 100%;
  height: 100%;
}
/* 内容 */
.blogs-cont{
  width: 100%;
  height: 100%;
  padding: 4% 0 6%;
}
.blogs-card{
  width: 80%;
  margin: 0 auto;
}
.blogs-card-item{
  height: 24vw;
  width: 100%;
  background: #FFFFFF;
  border-radius: 30px;
  padding: 3%;
  display: flex;
  gap: 2%;
  margin-bottom: 2%;
}
.blogs-card-item-img{}
.blogs-card-item-Font{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1%;
}
.blogs-card-item-Font strong{
  font-size: 2vw;
  color: #1E1E1E;
}
.blogs-card-item-Font p{
  font-size: 1vw;
  color: #959595;
  line-height: 2vw;
}
</style>